import React from 'react';
import { Link } from 'react-router-dom';
import '../Services.css'; // Using the main Services.css for consistency

const ServiceEducation: React.FC = () => {
  return (
    <div className="services-page">
      <div className="container">
        <div className="page-title">
          <h1>Education</h1>
          <p>Comprehensive educational resources for traders of all levels</p>
        </div>
        
        <div className="service-info">
          <h2>Comprehensive Trading Education</h2>
          <p>Our educational programs are designed to take you from a beginner to a professional trader. Whether you're just starting or looking to refine your skills, we have resources tailored for your level.</p>
          
          <div className="service-features">
            <div className="feature">
              <h3>Beginner Courses</h3>
              <p>Start with the basics of trading, market structure, and fundamental concepts.</p>
            </div>
            <div className="feature">
              <h3>Advanced Strategies</h3>
              <p>Learn sophisticated trading strategies and advanced technical analysis.</p>
            </div>
            <div className="feature">
              <h3>Practice Accounts</h3>
              <p>Apply your knowledge with risk-free demo trading accounts.</p>
            </div>
          </div>
        </div>
        
        <div className="education-levels">
          <h2>Education Levels</h2>
          <div className="education-grid">
            <div className="education-card">
              <h3>Beginner</h3>
              <ul>
                <li>Introduction to Financial Markets</li>
                <li>Understanding Trading Basics</li>
                <li>Technical Analysis Fundamentals</li>
                <li>Risk Management Principles</li>
              </ul>
              <Link to="#" className="btn">Start Learning</Link>
            </div>
            <div className="education-card">
              <h3>Intermediate</h3>
              <ul>
                <li>Advanced Chart Patterns</li>
                <li>Indicator Applications</li>
                <li>Trading Psychology</li>
                <li>Money Management</li>
              </ul>
              <Link to="#" className="btn">Start Learning</Link>
            </div>
            <div className="education-card">
              <h3>Advanced</h3>
              <ul>
                <li>Algorithmic Trading</li>
                <li>Quantitative Analysis</li>
                <li>Multi-Asset Strategies</li>
                <li>Performance Optimization</li>
              </ul>
              <Link to="#" className="btn">Start Learning</Link>
            </div>
          </div>
        </div>
        
        <div className="cta-section">
          <h2>Start Your Trading Education Journey</h2>
          <p>Access our comprehensive learning materials and become a skilled trader.</p>
          <Link to="/education" className="btn primary">Explore Main Education</Link>
        </div>
      </div>
    </div>
  );
};

export default ServiceEducation;